import React from 'react'
import { getMessage } from 'lib/translator'
import { Popup } from 'components/Popup'
import { LINKPASS_ADMIN_URL } from 'config/app'
import API from 'lib/api'

import './index.scss'

const MyinfoCta = ({ uid }) => {
  const [showPopup, setShowPopup] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const [isError, setIsError] = React.useState(false)

  const handleClosePopup = () => {
    setIsError(false)
    setLoading(false)
    setShowPopup(false)
  }

  const handleProceedButton = () => {
    setLoading(true)
    const api = new API({
      url: `${LINKPASS_ADMIN_URL}/linkpass-admin-service/user/uid/${uid}/myinfo`,
    })
    api
      .patch({ myinfo_last_verified: '2025-05-01T02:17:46.579Z' })
      .then((res) => {
        if (res.uid) {
          handleClosePopup()
        }
      })
      .catch(() => {
        setIsError(true)
        setLoading(false)
      })
  }

  return (
    <div className="myinfo-cta">
      <button className="myinfo-cta-button" onClick={() => setShowPopup(true)}>
        {getMessage('customer.details.pages.myinfoCta')}
      </button>
      <Popup
        show={showPopup}
        heading={'Reverify Myinfo'}
        close={handleClosePopup}
      >
        <div>
          {getMessage('customer.details.pages.myinfoCta.confirmationModal')}
        </div>
        {isError && (
          <div style={{ color: 'red', marginTop: '1rem' }}>
            Error Updating or you do not have the permissions. Please try again.
          </div>
        )}
        <div className="popup-buttons">
          <button onClick={handleClosePopup} className="cancel-button">
            Cancel
          </button>
          <button
            onClick={handleProceedButton}
            className="proceed-button"
            loading={loading}
            disabled={loading}
          >
            {loading ? 'Loading...' : 'Proceed'}
          </button>
        </div>
      </Popup>
    </div>
  )
}

export default MyinfoCta
